
	function CoursePopup(settings){
		this.className = "CoursePopup";

		this.name = "start-training";

		if(!settings) settings = {};

		settings = {

		};

		this.data = {
			pages: [
				{
					title: "Choose a person to start the course",
					name: "select-team",
					static: true,
					onRender: (e) => {
						//const $this = $(e.currentTarget);
						// Setup on click events for team members saving data id/name atrributes to values
						this.values.name = "Frank";
					}
				},
				{
					title: "Start training user",
					name: "share-course",
					static: true,
					onRender: (e) => {
						// Use values variable for populating page.
						this.$content.find('.js-name').text(this.values.name);
					}
				},
			]
		}

		this.setup(settings);
	};
	CoursePopup.inheritsFrom( PopupForm );

